import { Navigate, Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { useAuth } from '../hooks/useAuth';
import { ProjectProvider, useProject } from '../hooks/useProject';
import { Spinner } from '../components/ui';

/**
 * Authenticated shell. Doubles as the route guard: while the session check is
 * in flight we render a placeholder rather than flashing the login screen at a
 * user who is in fact signed in.
 *
 * The screen tree is keyed by the active project so a switch remounts every
 * screen and refetches everything under the new X-Project-Id scope.
 */
function Shell() {
  const { project, loading } = useProject();

  if (loading) return <Spinner label="Loading your projects…" />;

  return (
    <div className="app-shell">
      <Sidebar />
      <div className="main">
        <TopBar />
        <div className="content" key={project?.id ?? 'no-project'}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export function AppLayout() {
  const { account, loading } = useAuth();

  if (loading) return <Spinner label="Loading your account…" />;
  if (!account) return <Navigate to="/login" replace />;

  return (
    <ProjectProvider>
      <Shell />
    </ProjectProvider>
  );
}
